import { rei } from "@/services/api"
import http from 'http'
import https from 'https'

const httpAgent = new http.Agent({ keepAlive: true })
const httpsAgent = new https.Agent({ keepAlive: true })

class eHabilitacaoService {
  static joinDocuments (habilitacao, documentos = [], info = {}) {
    const data = { ...habilitacao, info }
    if (documentos.length > 0) data.documentos = documentos

    return rei.post(`gera-pdf-of-docs-habilitacao-casamento`, data, {httpAgent}).then(res => res.data)
  }

  static getPdfAws (document_id) {
    return rei.get(`doc-habilitacao-casamento/${ document_id }`, { responseType: 'arraybuffer' }).then(res => res.data)
  }

  static updateOrdem (habilitacao_casamento_id, documents) {
    const data = {
      documentos: documents
    }

    return rei.put(`ordena-docs-habilitacao-casamento/${ habilitacao_casamento_id }`, data)
      .then(res => res.data)
  }
}

export default eHabilitacaoService
